

@if (regThankYouData | async; as data) {
  @if (isThankYouPage() | async) {
    <div>
      <div class="col-xs-12 registration_thankyou_mob">
        <div class="registration_thankyou_rightheadermob"><a href="/">{{"reviewpage.home" | cxTranslate}}</a> &gt; <span>{{"reviewpage.createAccount" | cxTranslate}}</span></div>
        <div class="clearboth"></div>
      </div>
      @if (currentSite == 'seqirusb2b-uk' && isNonWebEnabled) {
        <!--registration left navigation carried over from the review page, step 4 stays highlighted-->
        <div class="col-md-3 col-xs-12 registration_leftside no-padding-right">
          <div class="col-xs-12 col-md-12 registration_nagivation no-padding">
            <div class="registration_nagivationPart" id="registration_nagivationPart1">
              <div class="registration_nagivationNo">
                <div class="registration_nagivationNumeric">1</div>
              </div>
              <div class="registration_nagivationName">{{'progresslabel.userProfile' | cxTranslate}}</div>
            </div>
            <div class="registration_nagivationPart" id="registration_nagivationPart2">
              <div class="registration_nagivationNo">
                <div class="registration_nagivationNumeric">2</div>
              </div>
              <div class="registration_nagivationName inactive">{{'progresslabel.businessDetails' | cxTranslate}}</div>
            </div>
            <div class="registration_nagivationPart" id="registration_nagivationPart3">
              <div class="registration_nagivationNo">
                <div class="registration_nagivationNumeric">3</div>
              </div>
              <div class="registration_nagivationName inactive">{{'progresslabel.contactAddress' | cxTranslate}}</div>
            </div>
            <div class="registration_nagivationPart currentsection" id="registration_nagivationPart4">
              <div class="registration_nagivationNo">
                <div class="registration_nagivationNumeric">4</div>
              </div>
              <div class="registration_nagivationName active">{{'progresslabel.reviewConfirm' | cxTranslate}}</div>
            </div>
          </div>
        </div>
      } 
      @else {
        <div class="col-md-3 col-xs-12 registration_thankyou_leftside">
          <div class="col-xs-12 col-md-10 registration_thankyou_nagivation no-padding">
            <div class="registration_thankyou_nagivationName1">
              {{data.title}}
            </div>
            <div class="registration_thankyou_nagivationName2">
              {{data.text2}}
            </div>
          </div>
          <!-- added job bag codes -->
          @if (currentSite == 'seqirusb2b-uk') {
            <div class="col-xs-12 grbno no-padding margin-T10 margin-B10">
              {{data.jobBagCode}}
            </div>
          }
        </div>
      }
      <div  class="col-md-9  col-xs-12 registration_thankyou_rightside "  [ngClass]="{'nonwebenabled_rightside': isUkNonWebEnabled()}">
        <div class=" col-md-12 col-xs-12 registration_thankyou_parentheader no-padding-left">
          <div class="registration_thankyou_rightheader">
            <a href="#">{{"reviewpage.home" | cxTranslate}}</a> &gt; <span>{{"reviewpage.createAccount" | cxTranslate}}</span>
          </div>
          <div class="registration_thankyou_help" [innerHTML]="data.h2content">
          </div>
          <div class="clearboth"></div>
        </div>
        <div class="clearboth"></div>
        @if (currentSite == 'seqirusb2b-flu360') {
          <div class="registration_thankyou_textheader">
            {{data.content}}
          </div>
        }
        @if (currentSite == 'seqirusb2b-flu360') {
          <div>
            <div class="registration_thankyou_text">{{data.paragraphcontent}}</div>
            <div class="registration_thankyou_button">
              <a [routerLink]="data.urlLink">{{data.h3content}}</a>
            </div>
          </div>
        }
        @if (currentSite == 'seqirusb2b-uk') {
          <div class="fornonwebenabled">
            <div class="Loginthankheader uk_LoginThankHeader_NonWebEnabled">
              {{"reviewpage.thankyoutitle" | cxTranslate}}
            </div>
            <div class="registration_thankyou_text ">
              <!-- {{data.paragraphcontent}} -->
              {{"reviewpage.thankyoumessage" | cxTranslate}}
            </div>
            <div class="registration_thankyou_button">
              <a [routerLink]="'/register/join-account'">{{"reviewpage.exploreflu360" | cxTranslate}}</a>
            </div>
            <!-- added job bag codes -->
            @if (currentSite == 'seqirusb2b-uk') {
              <div class="col-xs-12 grbno no-padding margin-T10 margin-B10">
                {{data.jobBagCode}}
              </div>
            }
          </div>
        }
      </div>
      @if (currentSite == 'seqirusb2b-uk') {
        <div class="col-md-12  col-xs-12 registration_thankyou_rightside forwebenabled">
          <div class="clearboth"></div>
          <div class="Loginthankheader">
            {{"reviewpage.thankyoutitle" | cxTranslate}}
          </div>
          <div class="Loginthanktext">
            {{"reviewpage.thankyoumessage" | cxTranslate}}
            <!-- {{data.paragraphcontent}} -->
          </div>
          <a class="registerToMyProfile showPopupclick" [routerLink]="'/my-profile'"><div class="loginthankbtn">{{"reviewpage.gotomyprofile" | cxTranslate}}</div></a>
          <div class="col-xs-12 grbno no-padding margin-T10 margin-B10">
            {{data.jobBagCode}}
          </div>
        </div>
      }
    </div>
  }
}
